
export default function Privacy() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <header className="bg-white border-b-2 border-green-700">
        <div className="container mx-auto px-6 py-4">
          <a href="/" className="text-xl font-bold text-green-800" style={{ fontFamily: '"Noto Serif JP", serif' }}>
            合同会社Nature
          </a>
        </div>
      </header>

      <main className="container mx-auto px-6 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-2xl font-bold text-gray-800 mb-8 text-center" style={{ fontFamily: '"Noto Serif JP", serif' }}>
            プライバシーポリシー
          </h1>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3 border-l-4 border-green-700 pl-3">1. 個人情報の取得</h2>
              <p>当社は、お問い合わせやサービスのご利用に際して、お名前、メールアドレス、電話番号等の個人情報を取得することがあります。</p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3 border-l-4 border-green-700 pl-3">2. 個人情報の利用目的</h2>
              <p>取得した個人情報は、以下の目的で利用いたします。</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>お問い合わせへの回答</li>
                <li>サービスの提供・改善</li>
                <li>重要なお知らせの連絡</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3 border-l-4 border-green-700 pl-3">3. 個人情報の第三者提供</h2>
              <p>当社は、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者に提供することはありません。</p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3 border-l-4 border-green-700 pl-3">4. 個人情報の管理</h2>
              <p>当社は、個人情報の漏洩、滅失、毀損の防止のため、適切な安全管理措置を講じます。</p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3 border-l-4 border-green-700 pl-3">5. お問い合わせ</h2>
              <p>個人情報の取扱いに関するお問い合わせは、下記までご連絡ください。</p>
              <div className="mt-3 bg-gray-50 border border-gray-300 p-4">
                <p>合同会社Nature</p>
                <p>〒239-0831 神奈川県横須賀市ハイランド三丁目27番24号</p>
              </div>
            </section>
          </div>

          <div className="mt-12 text-center">
            <a href="/" className="inline-block px-6 py-2 border-2 border-green-700 text-green-700 hover:bg-green-700 hover:text-white transition-colors cursor-pointer">
              トップページへ戻る
            </a>
          </div>
        </div>
      </main>

      <footer className="bg-gray-100 border-t border-gray-300 py-6 mt-12">
        <div className="container mx-auto px-6 text-center text-sm text-gray-600">
          <p>© 2024 合同会社Nature All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
}
